/** Humanized relative timestamp for conversation rows: "just now", "5m ago",
 *  "3h ago", "2d ago", then a short calendar date ("Jul 4", or "Jul 4, 2024" when
 *  the year differs). Returns '' for missing/invalid input. `now` is injectable for
 *  deterministic tests. */
export function relativeTime(iso: string | undefined, now: number = Date.now()): string {
  if (!iso) { return '' }
  const then = new Date(iso).getTime()
  if (Number.isNaN(then)) { return '' }

  const sec = Math.max(0, Math.floor((now - then) / 1000))
  if (sec < 60) { return 'just now' }
  const min = Math.floor(sec / 60)
  if (min < 60) { return `${min}m ago` }
  const hr = Math.floor(min / 60)
  if (hr < 24) { return `${hr}h ago` }
  const day = Math.floor(hr / 24)
  if (day < 7) { return `${day}d ago` }

  const d = new Date(then)
  const sameYear = d.getFullYear() === new Date(now).getFullYear()
  return d.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    ...(sameYear ? {} : { year: 'numeric' }),
  })
}
